import { module as BaseModule } from 'modujs';
import { html } from '../utils/dom';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        card: 'openModal',
        close: 'close'
      }
    };

    this.modal = null;
  }

  setupOpenCloseAnimation() {
    this.modal = this.$('modal')[0];
    const originalShowModal = this.modal.showModal;
    const originalClose = this.modal.close;

    this.modal.showModal = () => {
      originalShowModal.call(this.modal);
      this.modal.classList.add('is-open');
    };

    this.modal.close = () => {
      this.modal.addEventListener(
        'transitionend',
        (ev) => originalClose.call(this.modal),
        {once: true}
      );
      this.modal.classList.remove('is-open');
    }
  }

  openModal(ev) {
    const card = ev.currentTarget;
    const title = card.querySelector('.c-summary_card_title').cloneNode(true);
    const text = card.querySelector('.c-summary_card_inner_text').cloneNode(true);
    const image = card.querySelector('.c-summary_card_inner_image').cloneNode(true);
    const button = card.querySelector('.c-summary_card_inner_button')?.cloneNode(true);

    text.classList.remove('u-hidden-visually');
    image.classList.remove('u-hidden-visually');

    this.modal.querySelector('.c-summary_modal_title').innerHTML = title.outerHTML;
    this.modal.querySelector('.c-summary_modal_text').innerHTML = text.innerHTML;
    this.modal.querySelector('.c-summary_modal_image').innerHTML = image.innerHTML;

    if (button) {
      this.modal.querySelector('.c-summary_modal_button').innerHTML = button.innerHTML;
    } else {
      this.modal.querySelector('.c-summary_modal_button').innerHTML = '';
    }

    html.classList.add('has-summary-card-open');
    this.modal.showModal();
  }

  close() {
    html.classList.remove('has-summary-card-open');
    this.modal.close();
  }

  attachEscapeKeyEvent() {
    this.modal.addEventListener('cancel', (ev) => {
      ev.preventDefault();
      this.close();
    })
  }

  init() {
    this.setupOpenCloseAnimation();
    this.attachEscapeKeyEvent();
  }
}
